import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { InformationBoxes } from 'components/common/informationBoxes/informationBoxes';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import classes from 'components/widgets/WholeProjectRow/components/WholeProjectRow.module.scss';

interface RowElement {
    color?: string;
}

const WholeProjectRow = ({ columns, row, check, versionHashCode = undefined }) => {
    return (
        <>
            <InformationBoxes className={classes.row}>
                {columns
                    .filter((_item, index) => index > 0)
                    .map((oneCol, index) => {
                        const displayValue = row[oneCol.accessorKey];
                        const id = `WholeProjectRow_${oneCol.accessorKey}`;
                        const rowElStyle: RowElement = {};
                        if (oneCol.colorable) {
                            rowElStyle.color = oneCol?.calculatedColor;
                        }

                        return (
                            <InformationBoxes.Box key={id}>
                                <div className={classes.box}>
                                    <div className={'colHeader'}>{oneCol.header}</div>

                                    {oneCol.clickable ? (
                                        <LinkCell
                                            key={'linkCell' + index}
                                            id={id}
                                            value={displayValue}
                                            style={{ color: oneCol?.calculatedColor }}
                                            check={check}
                                            versionHashCode={versionHashCode}
                                        />
                                    ) : (
                                        <div key={oneCol.accessorKey + displayValue} style={rowElStyle} id={id}>
                                            {displayValue}
                                        </div>
                                    )}
                                </div>
                            </InformationBoxes.Box>
                        );
                    })}
            </InformationBoxes>
            <div className={classes.separatorWrapper}>
                <div className={classes.separator} />
            </div>
        </>
    );
};

export default WholeProjectRow;

const LinkCell = ({ value, style, check, id, versionHashCode = undefined }) => {
    const safeCheck = check.replace('/', '_');

    const fullPath = AppRoutes.buildPath(
        AppRoutes.DASHBOARD_PLANNING_PATH,
        riskConfig.logicQualityCheck.link,
        versionHashCode,
        'All',
        safeCheck,
        'activities',
    );

    const relativePath = `${safeCheck}/activities`;

    // If versionHashCode exists create full path link, used in report for full reroute
    const path = versionHashCode ? fullPath : relativePath;

    return value ? (
        <Link className={classes.turquoise} to={path} style={style} id={id}>
            {value}
        </Link>
    ) : (
        <div style={style} id={id}>
            {value}
        </div>
    );
};
